'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return { methods: methods, computed: computed, directives: directives };
};

var methods = require('./mixins/methods');
var computed = require('./mixins/computed');
var directives = require('./mixins/directives');


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/table.js
// module id = YcM/
// module chunks = 0